import moment from "moment"
import React, { useState } from "react"
import { Col, FormGroup, Input, InputGroup, Label, Row } from "reactstrap"
import PageBody from "../../../components/PageBody"
import Select, { components } from 'react-select'
import NumberFormat from "react-number-format"
import TextUtils from "../../../helpers/TextUtils"
import { Type, ValueText } from "../ProductAdd"
import { ProductStatus, ProductType } from "../ProductList"
import 'react-image-lightbox/style.css'
import profilePic from '../../../assets/images/users/no-img.jpg'
import { usageList, usedUnits } from "./ProductInfo"
import { WithContext as ReactTags } from 'react-tag-input';
import AsyncSelect from "react-select/async";
import APIClient from "../../../helpers/APIClient";
import { baseUrl } from "../../../constants/environment";
import { MultiSelect } from "react-multi-select-component";


const ProductViewInfo = (props: any) => {
    const { data, imgs, setData, type, onlyView, handleChangeInput, category, brand, origin, validation, age, pathologicals, loading, setLoading } = props
    const [isOpen, setIsOpen] = useState(false);
    const [imgIndex, setImgIndex] = useState(0);
    const [queryPathologicals, setQueryPathologicals] = useState('');

    const handleFilterMulti = (name: string, option: any, onChange: any) => {
        const value: any = []
        option && option.map((item: any) => {
            value.push(item)
        })
        onChange({ target: { name, value } })

    }

    const getFilterMulti = (list: any, value: any) => {
        if (value instanceof Array) {
            const option: any = []
            list && list.map((item: any) => {
                const found = value.length > 0 && value.find((element: any) => element == item.value);
                if (found || found === 0) {
                    option.push(item)
                }
            })
            return option
        }
        return []
    }

    let images = imgs?.reduce((prev: any, item: any) => {
        prev = [...prev, {
            title: data?.name,
            caption: data?.name,
            url: item?.url,
        }]
        return prev
    }, [])

    if (images?.length === 0) {
        images = [{
            title: data?.name,
            caption: data?.name,
            url: profilePic,
        }]
    }

    const KeyCodes = {
        comma: 188,
        enter: 13
    };

    const delimiters = [KeyCodes.comma, KeyCodes.enter];

    const setTags = (value: any) => {
        handleChangeInput({ target: { name: 'ingredient', value } })
    }

    const handleDelete = (i: any) => {
        const item = data?.ingredient[i]
        setTags(data?.ingredient.filter((tag: any, index: number) => index !== i));
    };

    const handleAddition = (tag: any) => {
        setTags([...data?.ingredient, {
            ...tag,
            name: tag?.text,
        }]);
    };

    const handleTagClick = (index: number) => {
        console.log('The tag at index ' + index + ' was clicked');
    };

    const handleChangePathologicals = (newValue: any) => {
        setQueryPathologicals(newValue);
        return newValue;
    };

    const loadPathologicalsSearchs = async () => {
        setLoading(true)
        let response: any = await APIClient.GET(`${baseUrl}/product/pathologicals`, {
          page: 1,
          limit: 20,
          name: queryPathologicals,
        });
        setLoading(false)
        if (response.response?.data !== undefined) {
          let Arr: any = [];
          response.response?.data?.map((e: any) => {
            Arr?.push({
              value: e?.id,
              label: e?.name,
              ...e,
            });
          });
          return Arr
        }
    };

    const handleMultiSelect = (name: string, option: any, onChange: any) => {
        const value: any = [];
        option &&
          option.map((item: any) => {
            value.push({
              id: item?.id,
              label: item?.label,
              value: item?.id
            });
          });
        onChange({ target: { name, value } });
    };
    
    console.log('siuDAtaProduct', data)

    return (
        <PageBody>
            <div className="nutri-title mb-3">Thông tin sản phẩm</div>
            <Row>
                <Col md={12} xs={12}>
                    <Row>
                        <Col md={6} xs={12}>
                            <FormGroup className='nutri-form'>
                                <Label><span>*</span>Tên sản phẩm</Label>
                                <InputGroup>
                                    <Input disabled={props?.user?.store_id?.is_erp_stock} type="text" value={data?.name} onChange={(e: any) => handleChangeInput(e)} name="name" placeholder="Nhập tên sản phẩm..." />
                                </InputGroup>
                            </FormGroup>
                            <FormGroup className='nutri-form'>
                                <Label>Mô tả sản phẩm</Label>
                                <InputGroup>
                                    <Input type="textarea" rows={8} value={data?.description} onChange={(e: any) => handleChangeInput(e)} name="description" placeholder="Nhập mô tả sản phẩm..." />
                                </InputGroup>
                            </FormGroup>
                            <Row>
                            <Col md={6} xs={12}>
                            <FormGroup className='nutri-form'>
                                <Label>Thương hiệu</Label>
                                <InputGroup>
                                <Input
                                    type="text"
                                    placeholder={type === 'view' && !data?.brand_text ? '---' : "Nhập thương hiệu"}
                                    className="react-select mb-2"
                                    disabled={onlyView}
                                    onChange={(event) => {
                                        // setData({ ...data, brand_text: event.target.value })
                                        handleChangeInput({ target: { name: 'brand_text', value: event.target.value } })
                                    }}
                                    value={data.brand_text}
                                />
                                 </InputGroup>
                            </FormGroup>
                        </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Xuất xứ</Label>
                                        <InputGroup>
                                        <Input
                                            placeholder={type === 'view' && !data?.origin_text ? '---' : "Nhập dữ liệu..."}
                                            className="react-select mb-2"
                                            disabled={onlyView}
                                            onChange={(event) => {
                                                setData({ ...data, origin_text: event.target.value });
                                            }}
                                            value={data.origin_text}
                                            style={{
                                                ...customStyles,
                                                minWidth: 250,
                                            }}
                                        />
                                        {validation?.origin_text && <div className="invalid-feedback d-block" >{validation?.origin_text}</div>}
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Kiểu quản lý</Label>
                                        <Select
                                            placeholder={type === 'view' && !data?.type ? '---' : "Chọn kiểu"}
                                            className="react-select mb-2"
                                            classNamePrefix="react-select"
                                            isDisabled={onlyView || props?.user?.store_id?.is_erp_stock}
                                            onChange={(val: any) => {
                                                setData({ ...data, type: val?.value })
                                            }}
                                            value={Type?.filter(
                                                (option: any) => data?.type == option.value
                                            )}
                                            options={Type}
                                            styles={{
                                                ...customStyles,
                                                menu: ({ width, ...css }) => ({
                                                    ...css,
                                                    minWidth: 200,
                                                }),
                                            }}
                                        ></Select>
                                        {validation?.type && <div className="invalid-feedback d-block" >{validation?.type}</div>}
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={6} xs={12}>
                            <Row>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label><span>*</span>Danh mục</Label>
                                        <Select
                                            placeholder={type === 'view' && !data?.category_id ? '---' : "Danh mục"}
                                            className="react-select mb-2"
                                            classNamePrefix="react-select"
                                            isDisabled={onlyView}
                                            onChange={(val: any) => {
                                                // setData({ ...data, category_id: val?.value })
                                                handleChangeInput({ target: { name: 'category_id', value: val?.value } })
                                            }}
                                            value={category?.filter(
                                                (option: any) => data?.category_id == option.value
                                            )}
                                            options={category}
                                            styles={{
                                                ...customStyles,
                                                menu: ({ width, ...css }) => ({
                                                    ...css,
                                                    minWidth: 300,
                                                }),
                                            }}
                                        ></Select>
                                        {validation?.category_id && <div className="invalid-feedback d-block" >{validation?.category_id}</div>}
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label><span>*</span>Loại sản phẩm</Label>
                                        <Select
                                            placeholder={type === 'view' && !data?.product_type ? '---' : "Chọn Loại sản phẩm"}
                                            className="react-select mb-2"
                                            classNamePrefix="react-select"
                                            isDisabled={onlyView}
                                            onChange={(val: any) => {
                                                setData({ ...data, product_type: val?.value })
                                            }}
                                            value={ProductType?.filter(
                                                (option: any) => data?.product_type == option.value
                                            )}
                                            options={ProductType}
                                            styles={{
                                                ...customStyles,
                                                menu: ({ width, ...css }) => ({
                                                    ...css,
                                                    minWidth: 300,
                                                }),
                                            }}
                                        ></Select>
                                        {validation?.product_type && <div className="invalid-feedback d-block" >{validation?.product_type}</div>}
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label><span>*</span>Đơn vị xuất kho</Label>
                                        <InputGroup>
                                            <Input disabled={props?.user?.store_id?.is_erp_stock} type="text" value={data?.minimum_unit} onChange={(e: any) => handleChangeInput(e)} name="minimum_unit" placeholder="Nhập đơn vị..." />
                                            {validation?.minimum_unit && <div className="invalid-feedback d-block" >{validation?.minimum_unit}</div>}
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Loại đường dùng</Label>
                                        <Select
                                            className="react-select mb-2"
                                            classNamePrefix="react-select"
                                            placeholder="Chọn loại đường dùng"
                                            options={usageList}
                                            isMulti
                                            onChange={(val: any) => { handleFilterMulti('usage', val, handleChangeInput) }}
                                            value={data?.usage || []}
                                        ></Select>
                                        {validation?.usage && <div className="invalid-feedback d-block" >{validation?.usage}</div>}
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label><span>*</span>Đơn vị sử dụng</Label>
                                        <Select
                                            placeholder={type === 'view' && !data?.used_unit ? '---' : "Chọn đơn vị"}
                                            className="react-select mb-2"
                                            classNamePrefix="react-select"
                                            isDisabled={onlyView}
                                            onChange={(val: any) => {
                                                handleChangeInput({ target: { name: 'used_unit', value: val?.value } })
                                            }}
                                            value={usedUnits?.filter(
                                                (option: any) => data?.used_unit == option.value
                                            )}
                                            options={usedUnits}
                                        ></Select>
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Trạng thái</Label>
                                        <Select
                                            placeholder={type === 'view' && !data?.status ? '---' : "Chọn trạng thái"}
                                            className="react-select mb-2"
                                            classNamePrefix="react-select"
                                            isDisabled={onlyView}
                                            onChange={(val: any) => {
                                                setData({ ...data, status: val?.value })
                                            }}
                                            value={ProductStatus?.filter(
                                                (option: any) => data?.status == option.value
                                            )}
                                            options={ProductStatus}
                                        ></Select>
                                        {validation?.status && <div className="invalid-feedback d-block" >{validation?.status}</div>}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                            <Col md={6} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label><span>*</span>Độ tuổi</Label>
                                        <Select
                                            className="react-select mb-2"
                                            classNamePrefix="react-select"
                                            placeholder="Chọn độ tuổi"
                                            options={age}
                                            onChange={(val: any) => {
                                                setData({
                                                    ...data,
                                                    product_age_id: val?.value
                                                })
                                            }}
                                            value={age?.filter((option: any) => option?.value == data?.product_age_id)}
                                        ></Select>
                                        {validation?.product_age_id && <div className="invalid-feedback d-block" >{validation?.product_age_id}</div>}
                                </FormGroup>
                            </Col>
                            <Col md={6} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label>Bệnh lý</Label>
                                    <AsyncSelect
                                        isMulti
                                        className="react-select mb-2"
                                        classNamePrefix="react-select"
                                        onInputChange={handleChangePathologicals}
                                        loadOptions={loadPathologicalsSearchs}
                                        inputValue={queryPathologicals}
                                        placeholder={loading ? "Đang tải dữ liệu..." : "Tìm kiếm tên"}
                                        noOptionsMessage={() => queryPathologicals ? "Không tìm thấy dữ liệu" : 'Tìm kiếm tên'}
                                        loadingMessage={() => 'Đang tìm kiếm...'}
                                        cacheOptions
                                        style={{ padding: 0 }}
                                        isDisabled={onlyView}
                                        onChange={(val: any) => {
                                            handleMultiSelect('product_pathological_ids', val, handleChangeInput)
                                        }}
                                        value={data?.product_pathological_ids}
                                        defaultOptions={pathologicals}
                                        components={{
                                            Menu: (props: any) => (
                                                <components.Menu {...props} >
                                                {props.children}
                                                </components.Menu>
                                            )
                                        }}
                                    ></AsyncSelect>
                                    {validation?.product_pathological_id && <div className="invalid-feedback d-block" >{validation?.product_pathological_id}</div>}
                                </FormGroup>
                            </Col>
                            </Row>
                            <FormGroup className='nutri-form'>
                                <Label>Thành phần</Label>
                                <ReactTags
                                    delimiters={delimiters}
                                    tags={data?.ingredient}
                                    handleDelete={handleDelete}
                                    handleAddition={handleAddition}
                                    handleTagClick={handleTagClick}
                                    inputFieldPosition="bottom"
                                    autocomplete
                                    readOnly={type === 'view'}
                                    placeholder='Thêm giá trị...'
                                />
                            </FormGroup>
                            {/* <Row>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Người tạo</Label>
                                        <ValueText>{!data?.created_uid ? "---":data?.created_uid?.name}</ValueText>
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Thời gian tạo</Label>
                                        <ValueText>{!data?.created_time ? "---":moment(data?.created_time).format('HH:mm:ss DD/MM/YYYY')}</ValueText>
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Thời gian cập nhật</Label>
                                        <ValueText>{!data?.updated_time ? "---":moment(data?.updated_time).format('HH:mm:ss DD/MM/YYYY')}</ValueText>
                                    </FormGroup>
                                </Col>
                            </Row> */}
                            {data?.type === 'batch' &&
                                <Row>
                                    <Col md={4} xs={12}>
                                        <FormGroup className='nutri-form'>
                                            <Label>Ngày đến hạn</Label>
                                            <InputGroup>
                                                <NumberFormat
                                                    disabled={onlyView}
                                                    onChange={(e: any) => handleChangeInput({ target: { name: "expiration_day_number", value: TextUtils.onlyNumber(e.target.value) } })}
                                                    name={'expiration_day_number'} type={'text'} className="form-control"
                                                    value={type === 'view' && !data?.expiration_day_number ? '---' : data?.expiration_day_number}
                                                    placeholder={(type == 'view' && !data?.expiration_day_number) ? "---" : "Nhập giá trị..."} thousandSeparator={true}
                                                />
                                                {validation?.expiration_day_number && <div className="invalid-feedback d-block" >{validation?.expiration_day_number}</div>}
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                    <Col md={4} xs={12}>
                                        <FormGroup className='nutri-form'>
                                            <Label>Ngày cảnh báo</Label>
                                            <InputGroup>
                                                <NumberFormat
                                                    disabled={onlyView}
                                                    onChange={(e: any) => handleChangeInput({ target: { name: "warning_day_number", value: TextUtils.onlyNumber(e.target.value) } })}
                                                    name={'warning_day_number'} type={'text'} className="form-control"
                                                    value={type === 'view' && !data?.warning_day_number ? '---' : data?.warning_day_number}
                                                    placeholder={(type == 'view' && !data?.warning_day_number) ? "---" : "Nhập giá trị..."} thousandSeparator={true}
                                                />
                                                {validation?.warning_day_number && <div className="invalid-feedback d-block" >{validation?.warning_day_number}</div>}
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                </Row>}
                        </Col>
                    </Row>

                </Col>

            </Row>
        </PageBody>
    )
}

const customStyles = {
    menuList: (base: any) => ({
        ...base,
        maxHeight: 200,
        overflowY: "auto"
    }),
};
export default ProductViewInfo